import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onKeydown"]

import { ref, nextTick, computed } from 'vue'
import { Edit } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
import { useMiscStore } from '@/stores/misc'
import { useSdkStore } from "@/stores/sdk";

export default /*@__PURE__*/_defineComponent({
  __name: 'templateName',
  setup(__props) {

const miscStore = useMiscStore()
const templateName = computed({
    get: () => miscStore.getTemplateName(),
    set: (val: string) => miscStore.setTemplateName(val)
})
const isEdit = ref(false)
const inputRef = ref<HTMLInputElement | null>(null)

const handleClick = () => {
    isEdit.value = true
    nextTick(() => {
        inputRef.value?.focus()
    })
}
const inputBlur = () => {
    isEdit.value = false
}
const onEnter = () => {
    saveTemplateName()
    // console.log('qweqweqweqwe')
}
const saveTemplateName = () => {
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    sdk.designOpt?.saveTemplate()
    // saveTemplate()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "inputName",
    onClick: handleClick
  }, [
    _withDirectives(_createElementVNode("div", { class: "name" }, _toDisplayString(templateName.value), 513), [
      [_vShow, !isEdit.value]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((templateName).value = $event)),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (isEdit.value = true)),
      ref_key: "inputRef",
      ref: inputRef,
      onBlur: inputBlur,
      onKeydown: _withKeys(_withModifiers(onEnter, ["stop","prevent"]), ["enter"])
    }, null, 40, _hoisted_1), [
      [_vShow, isEdit.value],
      [_vModelText, templateName.value]
    ]),
    _createVNode(_unref(ElIcon), {
      size: 20,
      onClick: inputBlur
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Edit))
      ]),
      _: 1
    })
  ]))
}
}

})